module.exports = __webpack_public_path__ + "static/img/bg-home-flight.39e83276.jpg";